<template>
    <Modal v-model="visible" :loading="modalLoading" :closable="true" mask-closable
        :title="getTranslation('e041')" width="80">
        <!-- Loading state -->
        <div v-if="modalLoading" class="loading-wrapper">
            <Spin size="large" fix></Spin>
        </div>
        <!-- Empty state -->
        <div v-else-if="!hasData" class="empty-state">
            <p>{{ getTranslation('b187') }}</p>
        </div>
        <!-- Data table -->
        <div v-else class="curve-data-table-wrapper">
            <table class="curve-data-table">
                <thead>
                    <tr>                        
                        <th class="col-axis">{{ axisLabel }}</th>
                        <th v-for="(s, si) in series" :key="si" class="col-series">
                            {{ s.name }}
                            <template v-if="si ==0">(KA)</template>
                            <template v-if="si ==1">(V)</template>
                            <template v-if="si ==2">(μOhm)</template>
                            <template v-if="si ==3">(KN)</template>
                            <template v-if="si ==4">(μOhm)</template>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(axisVal, idx) in axisData" :key="idx"
                        :class="{ 'row-odd': idx % 2 === 0 }">                        
                        <td class="col-axis">{{ axisVal }}</td>
                        <td v-for="(s, si) in series" :key="si" class="col-series">
                            {{ formatVal(s.data[idx]) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div slot="footer">
            <Row type="flex" class="menu-actions">
                <Col flex="1" class="flex-right">
                <Button type="default" size="small" icon="md-close" @click="cancel">{{ getTranslation('m063') }}</Button>&nbsp;
                </Col>
            </Row>
        </div>
    </Modal>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
    name: 'CurveData',
    components: {
       
    },
    props: {
        propVisible: Boolean,
        axisData: { type: Array, default: () => [] },
        series: { type: Array, default: () => [] },
    },
    data() {
        return {
            modalLoading: true,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        visible: {
            get() { return this.propVisible },
            set(val) { this.$emit('input', val) }
        },
        hasData() {
            return this.axisData && this.axisData.length > 0
                && this.series && this.series.length > 0;
        },
        axisLabel() {
            return this.getTranslation('p096') || 'Axis';
        },
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.modalLoading = false;
            }
        }
    },
    methods: {
        cancel() {
            this.visible = false;
        },
        formatVal(v) {
            if (v === undefined || v === null) return '-';
            if (typeof v === 'number') {
                // Keep reasonable precision, trim trailing zeros
                const s = v.toFixed(2);
                return parseFloat(s).toString();
            }
            return v;
        },
    },
}
</script>

<style scoped>
@import url('../assets/style/list.css');

.loading-wrapper {
    min-height: 200px;
    position: relative;
}

.empty-state {
    min-height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
}

.curve-data-table-wrapper {
    max-height: 65vh;
    overflow: auto;
    border: 1px solid #e8eaec;
    border-radius: 4px;
}

.curve-data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    white-space: nowrap;
}

.curve-data-table thead {
    position: sticky;
    top: 0;
    z-index: 2;
}

.curve-data-table thead th {
    background: #f5f6fa;
    color: #515a6e;
    font-weight: 600;
    padding: 8px 12px;
    border-bottom: 2px solid #dcdee2;
    text-align: center;
}

.curve-data-table tbody td {
    padding: 4px 12px;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
    color: #333;
}

.curve-data-table .row-odd td {
    background: #f9fafc;
}

.curve-data-table tbody tr:hover td {
    background: #e8f4fd;
}

.col-index {
    width: 50px;
    color: #999;
    font-size: 12px;
}

.col-axis {
    width: 100px;
    font-variant-numeric: tabular-nums;
}

.col-series {
    min-width: 120px;
    font-variant-numeric: tabular-nums;
}
</style>
